<template>
    <div>
        <SToolbar>
            <KpIcon icon-cls="agenda" color="grey" left />
            <v-toolbar-title>{{ $t('agenda') }}</v-toolbar-title>
        </SToolbar>

        <EventList session-key="event-list" height="var(--usable-height-with-double-toolbar)" />
    </div>
</template>

<script>
import EventList from '@/components/event/List.vue';

export default {
    name: 'EventIndex',

    components: {
        EventList,
    },
};
</script>
